import {
  AUTH_LOGOUT,
  APPLICATION_WIPE_DATA,
  AUTH_LOGIN,
  ORGANIZATION_UPDATE,
  ORGANIZATION_SWITCH,
  ORGANIZATION_ATTACH_ORG_ID,
  APP_IS_READY,
} from 'shared/store/actions';
import { STORAGE_KEYS } from 'shared/constants/storageKeys';

let lastOrganizationId;

const ORGANIZATION_RELATED_ACTIONS = [
  AUTH_LOGOUT,
  APPLICATION_WIPE_DATA,
  AUTH_LOGIN,
  ORGANIZATION_UPDATE,
  ORGANIZATION_SWITCH,
  ORGANIZATION_ATTACH_ORG_ID,
  APP_IS_READY,
];

const organizationIdChangeMiddleware =
  ({ getState }) =>
  next =>
  action => {
    // If the action is not related to organization, skip processing
    if (!ORGANIZATION_RELATED_ACTIONS.includes(action.type)) {
      next(action);
      return;
    }

    if (action.type === AUTH_LOGOUT || action.type === APPLICATION_WIPE_DATA) {
      localStorage.removeItem(STORAGE_KEYS.ORGANIZATION_ID);
      lastOrganizationId = undefined;
      next(action);
      return;
    }
    next(action);
    const state = getState();
    const currentOrganizationId = state?.organization?.id;

    // Update localStorage if organization ID exists and has changed (or is being set for the first time)
    if (currentOrganizationId && currentOrganizationId !== lastOrganizationId) {
      localStorage.setItem(STORAGE_KEYS.ORGANIZATION_ID, currentOrganizationId);
    }

    lastOrganizationId = currentOrganizationId;
  };

export const switchOrganizationMiddleware = [organizationIdChangeMiddleware];
